import React from "react";
import { Play, Pause, SkipForward, SkipBack, X, RadioButton, CircleNotch } from "@phosphor-icons/react";
import { useGospelRadio } from "../context/GospelRadioContext";

// Floating mini-player for Gospel Radio (live stream). Sits slightly
// above the Holy Words Radio bar so they never collide (they're
// mutually exclusive audio-wise, but both bars can be on screen).
export default function GospelRadioBar() {
  const { current, isPlaying, loading, toggle, next, prev, stop, stations } = useGospelRadio();
  if (!current) return null;

  return (
    <div
      data-testid="gospel-radio-bar"
      className="fixed left-4 z-[46] w-[min(440px,calc(100vw-2rem))] bottom-56 md:bottom-40"
    >
      <div className="glass rounded-2xl border border-forest/30 shadow-[0_-8px_32px_rgba(0,0,0,0.18)] pl-2 pr-3 py-2.5 flex items-center gap-2">
        <span className="relative shrink-0 w-9 h-9 rounded-full bg-forest text-cream grid place-items-center overflow-hidden">
          {current.favicon
            ? <img src={current.favicon} alt="" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} />
            : <RadioButton size={16} weight="fill" />}
          {isPlaying && <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse" />}
        </span>
        {stations.length > 1 && (
          <button onClick={prev} data-testid="gospel-radio-prev" className="w-8 h-8 grid place-items-center text-forest hover:text-terracotta transition-colors" aria-label="Previous station">
            <SkipBack size={15} weight="fill" />
          </button>
        )}
        <button onClick={toggle} data-testid="gospel-radio-toggle" className="w-10 h-10 grid place-items-center text-forest hover:text-terracotta transition-all hover:scale-105 active:scale-95" aria-label={isPlaying ? "Pause" : "Play"}>
          {loading ? <CircleNotch size={18} className="animate-spin" /> : (isPlaying ? <Pause size={20} weight="fill" /> : <Play size={20} weight="fill" />)}
        </button>
        {stations.length > 1 && (
          <button onClick={next} data-testid="gospel-radio-next" className="w-8 h-8 grid place-items-center text-forest hover:text-terracotta transition-colors" aria-label="Next station">
            <SkipForward size={15} weight="fill" />
          </button>
        )}
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.16em] text-red-600 font-bold leading-none flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500 inline-block" /> Live · Gospel Radio
          </div>
          <div className="text-forest font-semibold text-sm truncate leading-tight" data-testid="gospel-radio-title">{current.name}</div>
        </div>
        <button onClick={stop} data-testid="gospel-radio-close" className="shrink-0 w-9 h-9 grid place-items-center text-ink/60 hover:text-ink transition-colors" aria-label="Close">
          <X size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
}
